import type { ReactNode } from 'react';

import { Rating } from '@ui/uikit/components/common/Rating';

import { ApplicationValidationProgressBarItem } from '../ApplicationValidationProgressBarItem/ApplicationReviewProgressBarItem';
import styles from './ApplicationReviewDetals.module.scss';

type RowId = 1 | 2 | 3 | 4 | 5;

interface RowConfig {
  id: RowId;
  icon: ReactNode;
}

const ROWS: RowConfig[] = [
  {
    id: 5,
    icon: <Rating.Indicator value={5} />,
  },
  {
    id: 4,
    icon: <Rating.Indicator value={4} />,
  },
  {
    id: 3,
    icon: <Rating.Indicator value={3} />,
  },
  {
    id: 2,
    icon: <Rating.Indicator value={2} />,
  },
  {
    id: 1,
    icon: <Rating.Indicator value={1} />,
  },
];

interface ApplicationReviewDetailsProps {
  ratings?: Record<1 | 2 | 3 | 4 | 5 | 'all', number>;
}

export const ApplicationReviewDetails = ({ ratings }: ApplicationReviewDetailsProps) => {
  return (
    <div className={styles.container}>
      {ROWS.map(({ id, icon: Icon }) => {
        const all = ratings?.all ?? 0;
        const progressBar =
          all > 0 && ratings?.[id] != null ? Math.floor((ratings[id] * 100) / all) : 0;

        return <ApplicationValidationProgressBarItem key={id} value={progressBar} icon={Icon} />;
      })}
    </div>
  );
};
